export default {
  "pages.layouts.userLayout.title": "项目管理",
  "pages.login.pageTitle": "登录 / 注册",
  "pages.login.success": "登录成功",
  "pages.login.failure": "登录失败，请重试",
  "pages.login.email.placeholder": "邮箱",
  "pages.login.email.required": "请输入邮箱",
  "pages.login.email.invalid": "请输入有效的邮箱地址",
  "pages.login.brandPitch": "项目 · 任务 · 进度，为团队而生的一体化管理",
  "pages.login.heroTitle": "让项目，看得见。\n让延期，提前止损。",
  "pages.login.heroSubtitle":
    "甘特图与 WBS 一屏掌握进度，延期、阻塞、临近截止的风险提前预警，团队全局一目了然。",
  "pages.login.slogan.1": "甘特图，纵览全局。",
  "pages.login.slogan.2": "WBS，逐层拆解任务。",
  "pages.login.slogan.3": "延期之前，提前预警。",
  "pages.login.slogan.4": "依赖与进度，一目了然。",
  "pages.login.line": "使用 LINE 继续",
  "pages.login.google": "使用 Google 继续",
  "pages.login.or": "或",
  "pages.login.socialComingSoon": "{provider} 登录即将开放",
  "pages.login.privacy":
    "继续即表示同意我们的<terms>服务条款</terms>与<privacy>隐私政策</privacy>。",
  "pages.login.openMailbox.gmail": "打开 Gmail ↗",
  "pages.login.openMailbox.yahooJp": "打开 Yahoo!邮箱 ↗",
  "pages.login.openMailbox.yahoo": "打开 Yahoo Mail ↗",
  "pages.login.openMailbox.icloud": "打开 iCloud 邮箱 ↗",
  "pages.login.openMailbox.outlook": "打开 Outlook ↗",
  "pages.login.code.send": "用邮箱继续",
  "pages.login.code.placeholder": "6 位验证码",
  "pages.login.code.required": "请输入验证码",
  "pages.login.code.invalid": "请输入 6 位数字",
  "pages.login.code.sent": "验证码已发送",
  "pages.login.code.sentTo": "请输入发送到以下邮箱的验证码：{email}",
  "pages.login.code.sendFailed": "验证码发送失败",
  "pages.login.code.resendIn": "{seconds} 秒后可重新发送",
  "pages.login.code.resend": "重新发送验证码",
  "pages.login.continue": "继续",
  "pages.login.changeEmail": "← 修改邮箱",
  "pages.login.method.email": "邮箱",
  "pages.login.method.password": "账号・密码",
  "pages.login.username.placeholder": "用户名或邮箱",
  "pages.login.username.required": "请输入用户名或邮箱",
  "pages.login.password.placeholder": "密码",
  "pages.login.password.required": "请输入密码",
  "pages.login.password.submit": "登录",
  "pages.404.subTitle": "抱歉，您访问的页面不存在",
  "pages.404.buttonText": "返回首页",
  "pages.502.title": "无法连接到服务器",
  "pages.502.subTitle": "服务器暂时没有响应，请稍后重试。",
  "pages.502.buttonText": "重新加载",
  "pages.oauth.title": "登录处理中",
  "pages.oauth.processing": "登录处理中…",
  "pages.oauth.success": "登录成功",
  "pages.oauth.fetchUserFailed": "获取用户信息失败",
  "pages.oauth.backToLogin": "返回登录",
  "pages.oauth.error.stateMismatch": "认证信息无效，请重试。",
  "pages.oauth.error.googleFailed": "Google 认证失败，请重试。",
  "pages.oauth.error.disabled": "账号已被禁用。",
  "pages.oauth.error.closing": "该账号正在注销流程中，恢复请联系支持。",
  "pages.oauth.error.generic": "登录失败，请稍后重试。",

  // 通用
  "common.action": "操作",
  "common.edit": "编辑",
  "common.delete": "删除",
  "common.cancel": "取消",
  "common.confirm": "确认",
  "common.save": "保存",
  "common.created": "创建成功",
  "common.updated": "更新成功",
  "common.deleted": "删除成功",
  "common.createdAt": "创建时间",
  "common.reset": "重置",
  "common.export": "导出",
  "common.exporting": "正在导出...",
  "common.export.success": "导出成功",
  "common.export.noData": "没有可导出的数据",
  "common.import": "批量导入",
  "common.upload": "单击上传",

  // 设置
  "notifications.title": "通知消息",
  "settings.tab.account": "账户设置",
  "settings.tab.security": "安全设置",
  "settings.account.info": "账户信息",
  "settings.account.username": "用户名",
  "settings.account.tenant": "租户 ID",
  "settings.account.userCode": "用户编号",
  "settings.account.createdAt": "注册时间",
  "settings.account.displayName": "显示名称",
  "settings.account.displayNamePlaceholder": "请输入显示名称",
  "settings.account.displayNameHint": "设置后，将代替账号显示",
  "settings.account.save": "保存",
  "settings.account.displayNameSuccess": "显示名称已更新",
  "settings.password.title": "修改密码",
  "settings.password.setTitle": "设置密码",
  "settings.password.setHint":
    "你的账号通过邮箱/Google 登录，尚未设置密码。设置后即可使用「邮箱 + 密码」登录。无需旧密码，仅需邮箱验证码。",
  "settings.password.setSubmit": "设置密码",
  "settings.password.changeDesc":
    "使用邮箱验证码即可修改为新密码，无需填写当前密码。",
  "settings.password.setSuccess": "密码设置成功，现在可以使用邮箱 + 密码登录",
  "settings.password.old": "当前密码",
  "settings.password.new": "新密码",
  "settings.password.confirm": "确认新密码",
  "settings.password.minLength": "密码长度不能少于 6 位",
  "settings.password.mismatch": "两次输入的密码不一致",
  "settings.password.submit": "修改密码",
  "settings.password.success": "密码修改成功",
  "settings.password.code": "验证码",
  "settings.password.codePlaceholder": "6 位验证码",
  "settings.password.sendCode": "发送验证码",
  "settings.password.codeResendIn": "{seconds} 秒后重新发送",
  "settings.password.codeSent": "验证码已发送",
  "settings.password.codeSentTo": "验证码将发送至 {email}",
  "settings.password.codeInvalid": "请输入 6 位数字",
  "settings.tab.app": "App设置",
  "settings.app.title": "App定制",
  "settings.app.icon": "App图标",
  "settings.app.icon.desc":
    "上传自定义图标，用于移动应用展示。推荐使用 1024×1024 像素的 PNG 图片。",
  "settings.app.icon.upload": "上传图标",
  "settings.app.icon.change": "更换图标",
  "settings.app.icon.delete": "删除图标",
  "settings.app.icon.deleteConfirm": "确定删除当前图标吗？",
  "settings.app.icon.requirement": "PNG 格式，正方形，建议 1024×1024 px",
  "settings.app.icon.success": "图标更新成功",
  "settings.app.icon.deleteSuccess": "图标已删除",
  "settings.app.icon.sizeError": "图片尺寸需为正方形且不小于 512×512 像素",

  // --- 退出登录 ---
  "settings.account.logout": "退出登录",
  "settings.account.logoutDesc": "退出当前账户，下次需重新登录。",
  "settings.account.logoutConfirmTitle": "确认退出登录？",

  // --- 注销账户 ---
  "settings.account.dangerZone": "危险操作",
  "settings.account.deleteAccount": "注销账户",
  "settings.account.deleteAccountDesc":
    "注销后，账户将在30天后被永久删除。在此期间，您可以随时通过登录恢复账户。",
  "settings.account.deleteConfirmTitle": "确认注销账户？",
  "settings.account.deleteConfirmDesc":
    "请输入密码以确认注销。注销后您将被登出，30天内可通过登录恢复账户。",
  "settings.account.deleteConfirmPassword": "请输入密码",
  "settings.account.deleteConfirmEmailDesc":
    "请输入账户邮箱 {email} 以确认注销。注销后您将被登出，30天内可通过登录恢复账户。",
  "settings.account.deleteConfirmEmailRequired": "请输入账户邮箱",
  "settings.account.deleteConfirmEmailMismatch": "邮箱与账户不一致",
  "settings.account.deleteDataNotice": "30天后以下数据将被永久清空且无法恢复",
  "settings.account.deleteDataItem.records": "出入库记录",
  "settings.account.deleteDataItem.products": "产品记录",
  "settings.account.deleteDataItem.user": "用户信息",
  "settings.account.deleteSuccess": "账户注销请求已提交",

  // 通知
  "notice.tab.system": "系统通知",
  "notice.tab.todo": "待办提醒",
  "notice.empty": "暂无通知",
  "notice.todo.empty": "暂无待办",
  "notice.readAll": "全部标为已读",
  "notice.markSelectedRead": "标记已读",
  "notice.selected": "已选 {count} 条",
  "notice.viewAll": "查看全部",

  "notice.col.content": "消息内容",
  "notice.col.time": "接收时间",
  "notice.col.type": "消息类型",
  "notice.type.notice": "通知",
  "notice.type.announcement": "公告",
  "notice.detail.title": "消息详情",
  "notice.pagination.total": "共 {total} 条",

  // 团队邀请
  "invitation.inbox.title": "待处理邀请",
  "invitation.inbox.line": "{inviter} 邀请你加入「{team}」团队",
  "invitation.inbox.expiresAt": "有效期至 {date}",
  "invitation.accept": "接受",
  "invitation.decline": "拒绝",
  "invitation.declineConfirm": "确定要拒绝此邀请吗？",
  "invitation.acceptSuccess": "已加入「{team}」，可在右上角切换团队",
  // 邀请邮件深链接受页
  "invitation.accept.pageTitle": "团队邀请",
  "invitation.accept.loading": "正在确认邀请内容…",
  "invitation.accept.invalidTitle": "邀请链接无效",
  "invitation.accept.invalidDesc": "链接不正确或已失效，请让邀请人重新发送。",
  "invitation.accept.expiredTitle": "邀请已过期",
  "invitation.accept.expiredDesc": "该邀请已过期，请让邀请人重新发送。",
  "invitation.accept.acceptedTitle": "已接受",
  "invitation.accept.acceptedDesc": "该邀请已经被接受。",
  "invitation.accept.closedTitle": "该邀请已结束",
  "invitation.accept.declinedDesc": "该邀请已被拒绝。",
  "invitation.accept.revokedDesc": "该邀请已被撤销。",
  "invitation.accept.loginToAccept": "登录并加入",
  "invitation.accept.later": "稍后再说",
  "invitation.accept.mismatchDesc":
    "该邀请发往 {invited}，与当前账号（{current}）不一致。请用被邀请的邮箱登录。",
  "invitation.accept.switchAccount": "用其他账号登录",
  "invitation.accept.goApp": "进入系统",

  // 设置 - 通知消息

  // 设置 - 团队管理
  "settings.tab.team": "团队管理",
  "settings.tab.holidays": "节假日管理",
  "settings.tab.workday": "工时设置",
  "settings.tab.mcp": "MCP设置",
  // 工时设置标签页（1个工作日=多少小时）
  "pages.workday.title": "每日工时（工期换算）",
  "pages.workday.desc":
    "用于工期「天 ↔ 小时」的换算单位：1 个工作日 = 多少小时（默认 8h）。可适配不同公司/项目按 8h、7.5h 等计算。",
  "pages.workday.label": "1 个工作日 =",
  "pages.workday.unit": "小时",
  "pages.workday.save": "保存",
  "pages.workday.saved": "工时设置已保存",
  "pages.workday.range": "请输入 1〜24 之间的数值",
  "pages.workday.teamHint": "该设置对整个工作区的工期显示生效。",
  "pages.workday.ownerOnly": "该设置仅所有者可修改。",
  "pages.workday.note":
    "不会改动既有任务已填的天数/小时数据，仅改变总工期与工数的「小时换算」解释。",
  "settings.mcp.title": "AI 助手连接（MCP）",
  "settings.mcp.intro":
    "把此 URL 添加到你的 ChatGPT / Claude 后，直接用聊天说话就能操作本 PM 系统（查看、创建、更新任务等）。",
  "settings.mcp.urlLabel": "你的专属连接 URL",
  "settings.mcp.warning":
    "此 URL 是你的个人钥匙，请勿分享给他人。若泄露，可点「重新生成 URL」使其失效。",
  "settings.mcp.regenerate": "重新生成 URL",
  "settings.mcp.regenerateConfirm": "重新生成后当前 URL 立即失效，确定吗？",
  "settings.mcp.regenerated": "已生成新的 URL",
  "settings.mcp.setupTitle": "配置方法",
  "settings.mcp.claudeTitle": "在 Claude 中添加",
  "settings.mcp.chatgptTitle": "在 ChatGPT 中添加",
  "settings.mcp.cl1": "设置 → 连接器（不是「开发者 / 本地 MCP」）",
  "settings.mcp.cl2": "「添加自定义连接器」→ 粘贴上面的 URL",
  "settings.mcp.cl3": "在对话里启用「PM 助手」后开始说话",
  "settings.mcp.cg1": "设置 → 连接器 → 高级设置 打开「开发者模式」",
  "settings.mcp.cg2": "「添加自定义连接器」→ 粘贴上面的 URL（认证：无）",
  "settings.mcp.cg3": "在对话里选择「PM 助手」后开始说话",
  "settings.mcp.example":
    "例如：「告诉我〇〇项目里延期的任务」「把这段需求拆成任务并登记」",
  "team.name.title": "工作区名称",
  "team.name.desc":
    "工作区名称即你的租户名，会显示在团队切换器等位置，仅主账号可修改。",
  "team.name.edit": "修改",
  "team.name.placeholder": "请输入工作区名称",
  "team.name.required": "工作区名称不能为空",
  "team.name.success": "工作区名称已更新",
  "team.group.title": "团队",
  "team.group.desc":
    "在工作区下创建多个团队，邀请成员时可指定加入哪个团队（PRO 套餐）。成员只能看到所属团队的项目。",
  "team.group.create": "新建团队",
  "team.group.editTitle": "编辑团队",
  "team.group.col.name": "团队名称",
  "team.group.col.members": "成员数",
  "team.group.default": "默认",
  "team.group.members": "成员",
  "team.group.membersTitle": "「{name}」的成员",
  "team.group.membersDesc": "勾选加入该团队的成员；成员可同属多个团队。",
  "team.group.membersPlaceholder": "选择成员",
  "team.group.deleteConfirm":
    "确定删除团队「{name}」吗？（需先迁移或删除其下项目）",
  "team.group.nameRequired": "请输入团队名称",
  "team.invite.teams": "加入团队",
  "team.invite.teams.tip": "被邀请人接受后自动加入所选团队（可多选）。",
  "team.invite.teamsRequired": "请至少选择一个团队",
  "team.invite.teamsPlaceholder": "选择团队",
  "team.title": "团队成员",
  "team.invite": "邀请成员",
  "team.invite.title": "邀请新成员",
  "team.invite.email": "邮箱",
  "team.invite.emailInvalid": "请输入正确的邮箱",
  "team.invite.displayName": "显示名（可选）",
  "team.invite.displayName.tip": "对方接受邀请后默认使用此名称",
  "team.invite.message": "留言（可选）",
  "team.invite.checking": "正在检查邮箱…",
  "team.invite.alreadyMember": "该邮箱已经是本团队成员",
  "team.invite.alreadyPending":
    "该邮箱已有未处理的邀请，可点击「重发」重新发送邮件",
  "team.invite.accountExists":
    "该邮箱已注册项目管理系统，对方接受后将作为成员加入",
  "team.invite.accountNew": "对方将通过该邮箱注册并加入团队",
  "team.invite.success": "邀请已发送",
  "team.invite.resend": "重发",
  "team.invite.resendSuccess": "邀请已重发",
  "team.invite.revoke": "撤销",
  "team.invite.revokeConfirm": "确定撤销此邀请吗？",
  "team.invite.col.email": "邮箱",
  "team.invite.col.expiresAt": "过期时间",
  "team.invite.col.createdAt": "邀请时间",
  "team.invitations.title": "待处理邀请",
  "teamSwitcher.title": "切换团队",
  "lang.ja-JP": "日语",
  "lang.en-US": "英语",
  "lang.zh-CN": "简体中文",
  "lang.zh-TW": "繁体中文",
  "teamSwitcher.switched": "已切换到「{team}」",
  "team.col.displayName": "昵称",
  "team.col.username": "用户名",
  "team.col.role": "角色",
  "team.col.teams": "所属团队",
  "team.allTeams": "全部团队",
  "team.col.status": "状态",
  "team.role.owner": "主账号",
  "team.role.member": "成员",
  "team.status.active": "正常",
  "team.status.disabled": "已禁用",
  "team.status.invited": "待邀请",
  "team.edit": "编辑",
  "team.edit.success": "成员信息已更新",
  "team.remove": "移除",
  "team.remove.confirm": "确定移除该成员吗？移除后该账号将无法登录。",
  "team.disable": "禁用",
  "team.enable": "启用",
  "team.permissions": "权限配置",
  "team.permissions.title": "编辑权限 - {name}",
  "team.permissions.selectAll": "全选",
  "team.permissions.resetDefaults": "恢复默认",
  "team.permissions.resetDefaults.confirm": "确定恢复为默认权限吗？",
  "team.permissions.save.success": "权限配置已保存",
  "team.permissions.reset.success": "已恢复默认权限",
  "team.permissions.custom": "自定义",
  "team.permissions.default": "默认",
  "team.permissions.col.category": "分类",
  "team.permissions.col.target": "操作对象",
  "team.permissions.col.permissions": "功能权限",
  "team.permissions.group.product": "产品管理",
  "team.permissions.group.contact": "往来单位",
  "team.permissions.group.expense": "支出",
  "team.permissions.group.income": "收入",
  "team.permissions.group.analytics": "数据分析",
  "team.permissions.action.list": "查看",
  "team.permissions.action.add": "新增",
  "team.permissions.action.edit": "编辑",
  "team.permissions.action.delete": "删除",
  "team.permissions.action.void": "作废",
  "team.permissions.action.export": "导出",
  "team.permissions.action.view": "查看",
  "team.permissions.action.category": "分类管理",

  // 首次登录修改密码
  "changeInitialPassword.title": "修改初始密码",
  "changeInitialPassword.hint": "为了账号安全，建议修改初始密码",
  "changeInitialPassword.new": "新密码",
  "changeInitialPassword.confirm": "确认新密码",
  "changeInitialPassword.submit": "确认修改",
  "changeInitialPassword.skip": "跳过，稍后修改",
  "changeInitialPassword.success": "密码修改成功",

  // PM 俯瞰页
  "overview.title": "俯瞰",
  "overview.subtitle": "跨项目的遅延・风险一目了然，第一时间发现问题",
  "overview.view.all": "全社俯瞰",
  "overview.view.member": "我的任务",
  "overview.notMember": "当前账号尚未加入 PM 成员，无法查看「我的任务」",
  "overview.kpi.activeProjects": "进行中项目",
  "overview.kpi.delayedProjects": "遅延项目",
  "overview.kpi.delayedTasks": "遅延任务",
  "overview.kpi.blocked": "阻塞中",
  "overview.kpi.dueSoon": "本周到期",
  "overview.kpi.unassigned": "未分配",
  "overview.stat.title": "任务概览",
  "overview.stat.inProgress": "进行中的任务",
  "overview.stat.delayed": "延迟的任务",
  "overview.stat.delayed.tip": "点击只看延迟的任务",
  "overview.stat.thisWeek": "本周的任务",
  "overview.risk.title": "风险一览",
  "overview.risk.clearFilter": "清除筛选",
  "overview.risk.filter.delayed": "仅延迟任务",
  "overview.risk.empty": "没有遅延・风险 🎉",
  "overview.risk.col.kind": "风险",
  "overview.risk.col.project": "客户 / 项目",
  "overview.risk.col.task": "任务",
  "overview.risk.col.taskProject": "任务 / 客户・项目",
  "overview.risk.col.assignee": "担当",
  "overview.risk.col.due": "期日",
  "overview.risk.col.delay": "遅延",
  "overview.risk.col.progress": "进度",
  "overview.kind.overdue": "逾期",
  "overview.kind.behind": "进度滞后",
  "overview.kind.blocked": "依赖阻塞",
  "overview.kind.due-soon": "临近期日",
  "overview.kind.unassigned": "未分配",
  "overview.delay.overdueDays": "超期 {n} 天",
  "overview.delay.dueInDays": "还剩 {n} 天",
  "overview.delay.today": "今日",
  "overview.unassignedLabel": "未分配",
  "overview.health.title": "项目健康",
  "overview.health.empty": "暂无项目",
  "overview.health.delayBadge": "遅延 {n}",
  "overview.assignee.title": "任务数按担当者分布",
  "overview.assignee.empty": "暂无已指派任务",
  "overview.assignee.unassigned": "未指派",
  "overview.assignee.tasksUnit": "{n} 个",
  "overview.milestone.title": "本周里程碑",
  "overview.milestone.empty": "近期无里程碑",
  "overview.milestone.overdue": "超期 {n} 天",
  "overview.milestone.dueIn": "还剩 {n} 天",
  "overview.my.kpi.open": "负责中的任务",
  "overview.my.kpi.delayed": "延迟",
  "overview.my.kpi.thisWeek": "本周到期",
  "overview.my.kpi.bugs": "我的缺陷（未完成）",
  "overview.my.kpi.bugsHigh": "高 {n}",
  "overview.my.count": "未完成 {n} 件",
  "overview.my.countShort": "{n} 件",
  "overview.my.noDue": "无截止日",
  "overview.my.tasks.title": "我的任务",
  "overview.my.tasks.hint": "点击行打开甘特图",
  "overview.my.tasks.empty": "没有未完成的负责任务 🎉",
  "overview.my.bucket.overdue": "延迟",
  "overview.my.bucket.today": "今天",
  "overview.my.bucket.week": "本周",
  "overview.my.bucket.later": "下周及以后",
  "overview.my.more": "显示剩余 {n} 件",
  "overview.my.show": "显示",
  "overview.my.collapse": "收起",
  "overview.my.bugs.title": "我的缺陷",
  "overview.my.bugs.viewAll": "查看全部",
  "overview.my.bugs.empty": "没有未完成的负责缺陷",
  "overview.my.bugs.age": "{n} 天前",
  "overview.my.projects.title": "参与中的项目",
  "overview.my.milestones.title": "近期里程碑",

  // PM 日历（个人 / 全员月视图）
  "calendar.title": "日历",
  "calendar.subtitle": "一眼看清今天/本周要做的任务",
  "calendar.view.all": "全员",
  "calendar.view.member": "我的",
  "calendar.notMember": "当前账号未登记为 PM 成员，无法显示「我的」",
  "calendar.empty": "无相关任务",
  "calendar.today": "今天",
  "calendar.filter.all": "全部",
  "calendar.filter.task": "仅任务",
  "calendar.filter.event": "仅事件",
  "calendar.fullscreen": "全屏",
  "calendar.fullscreenExit": "退出全屏",

  // 事件 / 会议日程（嵌入日历）
  "event.legend": "事件类型",
  "event.type.meeting": "会议",
  "event.type.review": "评审",
  "event.type.milestone": "里程碑",
  "event.type.deadline": "截止",
  "event.type.other": "其他",
  "event.new": "新建事件",
  "event.edit": "编辑事件",
  "event.field.title": "标题",
  "event.field.type": "类型",
  "event.field.start": "开始",
  "event.field.end": "结束",
  "event.field.allDay": "全天",
  "event.field.project": "项目",
  "event.field.task": "关联任务",
  "event.field.attendees": "参加人",
  "event.field.location": "地点",
  "event.field.note": "备注",
  "event.field.projectGlobal": "全局（不挂项目）",
  "event.save": "保存",
  "event.cancel": "取消",
  "event.delete": "删除",
  "event.deleteConfirm": "确认删除该事件？",
  "event.saved": "已保存",
  "event.deleted": "已删除",
  "event.validate.title": "请输入标题",
  "event.validate.time": "请选择开始时间",
  "event.validate.endBeforeStart": "结束时间不能早于开始时间",

  // PM 项目管理
  "projects.title": "项目管理",
  "projects.subtitle": "按客户 / 产品组织项目，追踪每个项目的进度",
  "projects.create": "创建项目",
  "projects.count": "{count} 个项目",
  "projects.searchPlaceholder": "搜索项目…",
  "projects.filter.all": "全部",
  "projects.filter.placeholder": "按名称 / 说明筛选",
  "projects.filter.emptyKw": "该客户下没有匹配「{kw}」的项目",
  "projects.filter.bridge": "在任务 / Bug 中搜索「{kw}」",
  "projects.status.all": "全部状态",
  "projects.status.planned": "未开始",
  "projects.status.active": "进行中",
  "projects.status.paused": "已暂停",
  "projects.status.done": "已交付",
  "projects.selectCustomerFirst": "请先在左侧选择客户 / 产品",
  "projects.noMatch": "没有匹配的项目",
  "projects.emptyHint": "该客户还没有项目，点击「创建项目」开始",
  "projects.card.edit": "编辑项目",
  "projects.card.delete": "删除项目",
  "projects.card.noDesc": "暂无描述",
  "projects.card.enter": "进入",
  "projects.card.overdue": "已逾期",
  "projects.col.progress": "进度",
  "projects.col.actions": "操作",
  "projects.reordered": "排序已更新",
  "projects.drag.hint": "拖动以排序",
  "projects.drag.disabled": "清除搜索 / 筛选后方可拖动排序",
  "projects.customers.title": "客户 / 产品",
  "projects.customers.new": "新建客户 / 产品",
  "projects.customers.searchPlaceholder": "搜索客户…",
  "projects.customers.empty": "没有客户",
  "projects.customers.count": "{count} 个项目",
  "projects.customers.avg": "进度 {avg}%",
  "projects.customers.collapse": "收起列表",
  "projects.customers.expand": "展开列表",
  "projects.delete.title": "删除项目",
  "projects.delete.content":
    "确定删除「{customer} {name}」？该项目下的所有任务和依赖也会一并删除，且不可恢复。",
  "projects.delete.ok": "删除",
  "projects.deleted": "项目已删除",
  "projects.form.createTitle": "创建项目",
  "projects.form.editTitle": "编辑项目",
  "projects.form.create": "创建",
  "projects.form.save": "保存",
  "projects.form.customer": "客户 / 产品",
  "projects.form.customerRequired": "请选择客户",
  "projects.form.customerPlaceholder": "选择客户",
  "projects.form.name": "项目名称",
  "projects.form.nameRequired": "请输入项目名称，如 v1.0.0",
  "projects.form.namePlaceholder": "v1.0.0",
  "projects.form.description": "描述",
  "projects.form.descriptionPlaceholder": "本期主要内容…",
  "projects.form.status": "状态",
  "projects.form.statusRequired": "请选择状态",
  // ===== 种别（通常项目 / 运维保守） =====
  "projects.form.kind": "种别",
  "projects.form.kindRequired": "请选择种别",
  "projects.form.kindTip":
    "运维保守的需求随时追加、范围一直在变，因此不看达成率而看件数",
  "projects.kind.project": "通常项目",
  "projects.kind.projectDesc": "范围固定的项目，用进度率管理",
  "projects.kind.ops": "运维・保守",
  "projects.kind.opsDesc": "改修需求随时进来的长期项目，用件数管理",
  "projects.form.endRequired": "请选择结束日期",
  "projects.form.endOptional": "留空即为「持续中」",
  "projects.form.startPlaceholder": "开始日期",
  "projects.form.endPlaceholder": "结束日期",
  "projects.form.endOngoing": "持续中（未定）",
  "projects.card.ongoing": "持续中",
  "projects.ops.thisMonth": "本月完成 {done}/{total} 件",
  "projects.ops.open": "未完成 {count} 件",
  // ===== 月度工时额度（保守契约的「每月◯人日」） =====
  "projects.form.quota": "月度工时额度",
  "projects.form.quotaTip":
    "保守合同的「每月◯人日」。设置后列表会显示本月的消耗情况",
  "projects.form.quotaOptional": "留空即为不设额度（只显示件数）",
  "projects.form.quotaUnit": "人日 / 月",
  "projects.form.quotaPlaceholder": "例：20",
  "projects.ops.quotaActual": "实绩 {used} / {quota}",
  "projects.ops.quotaPlanned": "预定 {used} / {quota}",
  "projects.ops.quotaOver": "超额",
  "projects.ops.quotaTooltip": "本月 预定 {planned} · 实绩 {actual} · 额度 {quota}",
  "projects.form.range": "起止时间",
  "projects.form.rangeRequired": "请选择起止时间",
  "projects.updated": "项目已更新",
  "projects.created": "项目已创建",
  "projects.cancel": "取消",
  "projects.customer.created": "客户已创建",
  "projects.customer.createTitle": "新建客户 / 产品",
  "projects.customer.name": "名称（客户 / 产品）",
  "projects.customer.nameRequired": "请输入名称，如 東邦銀行",
  "projects.customer.namePlaceholder": "例：东邦银行 / 订货系统",
  "projects.customer.shortName": "简称",
  "projects.customer.shortNamePlaceholder": "可选，例：東邦 / 受発注",
  "projects.customer.team": "归属团队",
  "projects.customer.teamRequired": "请选择团队",
  "projects.customer.teamPlaceholder": "选择团队",
  "projects.customer.create": "创建",
  // ===== 甘特页 Tab =====
  "projects.gantt.tab.wbs": "详细WBS",
  "projects.gantt.tab.board": "看板",
  "projects.gantt.tab.roadmap": "导入计划",
  "projects.gantt.tab.design": "设计板",
  // ===== 看板视图 =====
  "projects.board.status.backlog": "待办池",
  "projects.board.status.todo": "待开始",
  "projects.board.status.inProgress": "进行中",
  "projects.board.status.testing": "测试",
  "projects.board.status.done": "已完成",
  "projects.board.status.cancelled": "已取消",
  "projects.board.empty": "暂无可在看板展示的任务",
  // ===== 右侧面板：视图切换 / 年度日程 =====
  "projects.view.list": "版本一览",
  "projects.view.annual": "年度日程",
  "projects.annual.newVersion": "新建版本",
  "projects.annual.empty": "{year} 年没有相关版本",
  "projects.annual.release": "发布",
  "projects.annual.today": "今天",
  // ===== 甘特页：WBS 表头 / 行操作 / 工具栏 =====
  "projects.gantt.col.name": "任务名",
  "projects.gantt.col.start": "开始时间",
  "projects.gantt.col.duration": "工期",
  "projects.gantt.col.progress": "进度",
  "projects.gantt.col.people": "人员",
  "projects.gantt.row.addChild": "添加子任务",
  "projects.gantt.row.edit": "编辑",
  "projects.gantt.row.delete": "删除",
  "projects.gantt.scale.day": "日",
  "projects.gantt.scale.week": "周",
  "projects.gantt.expandAll": "全部展开",
  "projects.gantt.collapseAll": "全部折叠",
  "projects.gantt.expandAllShort": "展开",
  "projects.gantt.collapseAllShort": "折叠",
  "projects.gantt.addTask": "添加任务",
  "projects.gantt.empty.desc": "还没有任务，点击「添加任务」开始排期",
  "projects.gantt.notFound": "项目不存在",
  "projects.gantt.deleteTask.title": "删除「{name}」？",
  "projects.gantt.deleteTask.summary":
    "该任务下的所有子任务及相关依赖将一并删除。",
  "projects.gantt.deleteTask.leaf": "相关依赖连线将一并删除。",
  // ===== 路线图视图 =====
  // dayjs 月份格式（时间轴表头）
  "projects.roadmap.monthFormat": "M月",
  "projects.roadmap.empty": "暂无可在路线图展示的项目",
  "projects.roadmap.lane.milestone": "里程碑",
  "projects.roadmap.lane.system": "系统",
  "projects.roadmap.lane.business": "业务",
  "projects.roadmap.lane.default": "其他",
  "projects.roadmap.party.client": "贵司作业",
  "projects.roadmap.party.vendor": "我司作业",
  "projects.roadmap.legend.client": "贵司作业",
  "projects.roadmap.legend.vendor": "我司作业",
  "projects.roadmap.msColor.critical": "关键（红）",
  "projects.roadmap.msColor.normal": "普通（灰）",
  "projects.roadmap.msColor.client": "贵司（绿）",
  "projects.roadmap.msColor.vendor": "我司（蓝）",
  "projects.roadmap.optionManager.entry": "泳道管理",
  "projects.roadmap.optionManager.title": "泳道 / 里程碑色 管理",
  "projects.roadmap.optionManager.teamHint": "修改将对整个团队生效",
  "projects.roadmap.optionManager.laneSection": "泳道",
  "projects.roadmap.optionManager.msColorSection": "里程碑色",
  "projects.roadmap.optionManager.addLane": "添加泳道",
  "projects.roadmap.optionManager.addMsColor": "添加颜色",
  "projects.roadmap.optionManager.namePlaceholder": "输入名称",
  "projects.roadmap.optionManager.system": "内置",
  "projects.roadmap.optionManager.deleteConfirm": "确定删除？",
  "projects.roadmap.optionManager.nameRequired": "请输入名称",
  // ===== 任务编辑：基本信息 =====
  "projects.taskForm.title.add": "添加任务",
  "projects.taskForm.title.edit": "编辑任务",
  "projects.taskForm.title.child": "在「{name}」下添加子任务",
  "projects.taskForm.name": "任务名",
  "projects.taskForm.nameRequired": "请输入任务名",
  "projects.taskForm.namePlaceholder": "如：詳細設計_S0390_画面",
  "projects.taskForm.type": "类型",
  "projects.taskForm.type.task": "普通任务",
  "projects.taskForm.type.summary": "汇总（阶段）",
  "projects.taskForm.type.milestone": "里程碑",
  "projects.taskForm.project": "所属项目（阶段）",
  "projects.taskForm.projectHint":
    "切换到其他项目会把该任务及其全部子任务一并移过去；跨项目的依赖连线会被清除。",
  "projects.taskForm.projectPlaceholder": "选择所属项目",
  "projects.taskForm.parent": "上级任务（父阶段）",
  "projects.taskForm.parentHint":
    "把任务挂到所选项目的某个汇总（阶段）下；留空＝置于最上层。",
  "projects.taskForm.parentRoot": "最上层（不挂任何阶段）",
  "projects.taskForm.derivedHint":
    "汇总（阶段）的工期与进度由其子任务自动汇总得出，无法直接编辑。请编辑子任务。",
  "projects.taskForm.summaryRangeOptionalHint":
    "可留空：添加子任务后将自动汇总工期；留空时暂以所属项目的周期占位。",
  "projects.taskForm.milestoneDate": "计划里程碑日",
  "projects.taskForm.planRange": "计划起止时间",
  "projects.taskForm.rangeRequired": "请选择计划时间",
  "projects.taskForm.rangeOutOfProject":
    "计划时间需在项目周期（{start} ~ {end}）范围内",
  "projects.taskForm.actualRange":
    "实际起止时间（未开始留空・仅填开始＝进行中）",
  "projects.taskForm.actualStartRequired": "填写结束日期时必须先填开始日期",
  "projects.taskForm.actualEndBeforeStart": "实际结束日期不能早于开始日期",
  "projects.taskForm.effort": "工期（天＋时）",
  "projects.taskForm.effortPlan": "计划工期（天＋时）",
  "projects.taskForm.effortActual": "实际工期（天＋时）",
  "projects.taskForm.effortTip":
    "工期可直接手填 天d＋时h（0〜23.75，可小数 0.25 步进）；留空则按期间（工作日 × 每日工时）自动算。可点下方[使用]套用建议值",
  "projects.taskForm.effortSuffix": "小时",
  "projects.taskForm.effortDaysSuffix": "天",
  "projects.taskForm.effortUse": "使用",
  "projects.taskForm.effortHint":
    "{days}d（{days}个工作日 ≈ {hours}h｜1天 {hpd}h）",
  "projects.taskForm.effortManualBadge": "手动设置",
  "projects.taskForm.effortAutoBadge": "按期间自动（{dur}）",
  "projects.taskForm.levels": "标签（可多个，回车新增）",
  "projects.taskForm.levelsPlaceholder": "输入标签后回车，如：重要 / 难 / 前端",
  "projects.taskForm.progress": "进度",
  "projects.taskForm.status": "状态",
  "projects.taskForm.assignee": "指派成员",
  "projects.taskForm.assigneePlaceholder": "选择成员",
  "projects.taskForm.description": "描述（可贴图）",
  "projects.taskForm.descriptionPlaceholder":
    "输入任务描述，可直接粘贴 / 拖拽截图…",
  // ===== 任务评论 =====
  "projects.comments.title": "评论",
  "projects.comments.empty": "还没有评论",
  "projects.comments.placeholder": "输入评论（⌘/Ctrl+Enter 发送）",
  "projects.comments.send": "发送",
  "projects.comments.emoji": "表情",
  "projects.comments.edited": "已编辑",
  "projects.comments.deleteConfirm": "确定删除这条评论？",
  // ===== 任务编辑：关联链接（设计稿 / Figma） =====
  // ===== 任务操作日志（抽屉右栏「操作日志」页签） =====
  "projects.activity.title": "操作日志",
  "projects.activity.empty": "还没有操作记录",
  "projects.activity.emptyHint": "编辑任务后会自动记录",
  "projects.activity.noneInFilter": "没有符合该条件的记录",
  "projects.activity.today": "今天",
  "projects.activity.none": "未设置",
  "projects.activity.ongoing": "未定",
  "projects.activity.autoEffort": "按期间自动",
  "projects.activity.showFull": "显示全文",
  "projects.activity.collapse": "收起",
  "projects.activity.filter.all": "全部操作",
  "projects.activity.filter.progress": "状态·进度",
  "projects.activity.filter.schedule": "日程·工期",
  "projects.activity.filter.people": "担当者·标签",
  "projects.activity.filter.other": "说明·其他",
  "projects.activity.action.created": "创建了此任务",
  "projects.activity.action.updated": "修改了 {count} 个字段",
  "projects.activity.action.updatedOne": "修改了 {field}",
  "projects.activity.action.childAdded": "添加了子任务",
  "projects.activity.action.childRemoved": "删除了子任务",
  "projects.activity.action.depAdded": "添加了依赖",
  "projects.activity.action.depRemoved": "解除了依赖",
  "projects.activity.field.name": "任务名",
  "projects.activity.field.type": "类型",
  "projects.activity.field.status": "状态",
  "projects.activity.field.progress": "进度",
  "projects.activity.field.planRange": "计划期间",
  "projects.activity.field.actualRange": "实际期间",
  "projects.activity.field.plannedEffort": "计划工期",
  "projects.activity.field.actualEffort": "实际工期",
  "projects.activity.field.assignees": "担当者",
  "projects.activity.field.levels": "标签",
  "projects.activity.field.description": "说明",
  "projects.activity.field.parent": "上级任务",
  "projects.activity.field.project": "所属项目",
  "projects.activity.field.roadmapVisible": "路线图",
  "projects.activity.field.roadmapLane": "泳道",
  "projects.activity.field.ownerParty": "作业区分",
  "projects.activity.field.milestoneColor": "里程碑颜色",
  "projects.activity.field.subtask": "子任务",
  "projects.activity.field.predecessor": "前置任务",
  "projects.activity.field.successor": "后续任务",
  "projects.activity.value.shown": "显示",
  "projects.activity.value.hidden": "隐藏",
  "projects.links.title": "设计",
  "projects.links.empty": "还没有关联设计稿",
  "projects.links.urlPlaceholder": "粘贴 Figma 链接（或其他网址）",
  "projects.links.titlePlaceholder": "备注名（可选，如「登录页 v2」）",
  "projects.links.add": "添加",
  "projects.links.figmaHint":
    "Figma 需设为「知道链接的任何人可查看」才能内联预览",
  "projects.links.open": "在新标签页打开",
  "projects.links.deleteConfirm": "确定移除这个链接？",
  // ===== 任务编辑：路线图设置 =====
  "projects.taskForm.roadmap.panel": "路线图设置",
  "projects.taskForm.roadmap.visible": "在路线图展示",
  "projects.taskForm.roadmap.lane": "泳道",
  "projects.taskForm.roadmap.lanePlaceholder": "选择泳道",
  "projects.taskForm.roadmap.ownerParty": "作业归属",
  "projects.taskForm.roadmap.milestoneColor": "里程碑颜色",
  "projects.taskForm.roadmap.milestoneColorPlaceholder": "选择颜色",

  // ===== 成员视图（资源视图） =====
  "resources.title": "成员视图",
  "resources.subtitle": "按成员俯瞰跨项目的任务分配，检测排期撞期 / 负载冲突",
  "resources.mode.single": "单人",
  "resources.mode.all": "全员",
  "resources.scale.day": "日",
  "resources.scale.week": "周",
  "resources.year.auto": "自动",
  "resources.range.start": "开始月份",
  "resources.range.end": "结束月份",
  "resources.hideCompleted": "隐藏已完成任务",
  "resources.member.placeholder": "选择成员",
  "resources.member.empty": "暂无成员",
  "resources.selectMemberFirst": "请先选择成员",
  "resources.empty": "该成员暂无任务",
  "resources.allEmpty": "暂无已指派的任务",
  "resources.loading": "加载中…",
  "resources.view.timeline": "时间轴",
  "resources.view.list": "列表",
  "resources.list.total": "共 {n} 条",
  "resources.col.task": "任务",
  "resources.col.project": "项目",
  "resources.col.assignee": "担当",
  "resources.col.plan": "计划",
  "resources.col.actual": "实际",
  "resources.col.progress": "进度",
  "resources.conflict.badge": "撞期",
  "resources.conflict.tip": "有 {count} 个任务时间重叠（同时承担多个项目）",
  "resources.conflict.legend": "撞期 / 负载冲突",
  "resources.noSchedule": "（未排期）",
  "resources.backToAll": "返回全员视图",
  "resources.openDetail": "查看该成员详情",
  "resources.editTask": "编辑任务",

  // ===== 工时实绩汇总（个人模式） =====
  "resources.stats.title": "工时实绩汇总",
  "resources.stats.note": "含已完成任务",
  "resources.stats.hpd": "1工作日={hpd}h",
  "resources.stats.hint":
    "按担当「关与」口径汇总（多担当任务对每人计全额工期，跨人合计会重复）。工期按 1 工作日={hpd}h 换算。",
  "resources.stats.collapse": "收起",
  "resources.stats.expand": "展开",
  "resources.stats.empty": "该期间无担当任务",
  "resources.stats.kpi.actual": "实绩合计工期",
  "resources.stats.kpi.planned": "计划合计工期",
  "resources.stats.kpi.tasks": "稼动任务数",
  "resources.stats.kpi.rate": "消化率",
  "resources.stats.kpi.unit": "项",
  "resources.stats.kpi.target": "对象 {n} 项",
  "resources.stats.kpi.done": "完成 {n}",
  "resources.stats.kpi.wip": "进行 {n}",
  "resources.stats.kpi.remain": "剩余 {v}",
  "resources.stats.kpi.over": "超出 {v}",
  "resources.stats.kpi.noPlan": "无计划",
  "resources.stats.kpi.noPlanShort": "无计划",
  "resources.stats.kpi.rateHint": "实绩 / 计划",
  "resources.stats.export.btn": "导出 Excel",
  "resources.stats.export.sheet1": "概要",
  "resources.stats.export.sheet2": "任务列表",
  "resources.stats.export.member": "成员",
  "resources.stats.export.period": "期间",
  "resources.stats.export.allPeriod": "全期间",
  "resources.stats.export.metric": "指标",
  "resources.stats.export.value": "值",
  "resources.stats.export.delta": "计划差",
  "resources.stats.export.doneLabel": "完成任务数",
  "resources.stats.export.wipLabel": "进行中任务数",
  "resources.stats.export.col.name": "任务名",
  "resources.stats.export.col.customer": "客户",
  "resources.stats.export.col.status": "状态",
  "resources.stats.export.col.planStart": "计划开始",
  "resources.stats.export.col.planEnd": "计划结束",
  "resources.stats.export.col.actualStart": "实际开始",
  "resources.stats.export.col.actualEnd": "实际结束",
  "resources.stats.export.status.done": "完成",
  "resources.stats.export.status.ongoing": "进行中(仅开始)",
  "resources.stats.export.status.wip": "进行中",
  "resources.stats.export.status.todo": "未着手",

  // ===== PM 客户 / 产品页 =====
  "customers.title": "客户 / 产品",
  "customers.subtitle": "管理客户与产品，作为项目的归属对象",
  "customers.new": "新建客户",
  "customers.create": "创建",
  "customers.search.placeholder": "搜索名称 / 简称…",
  "customers.count": "共 {count} 个客户 / 产品",
  "customers.col.name": "名称",
  "customers.col.shortName": "简称",
  "customers.col.projectCount": "项目数",
  "customers.col.createdAt": "创建日期",
  "customers.empty": "还没有客户，点击「新建客户」添加",
  "customers.edit": "编辑客户",
  "customers.delete.title": "删除「{name}」？",
  "customers.delete.hasProjects":
    "该客户下还有 {count} 个项目，删除后这些项目将失去所属客户。",
  "customers.delete.irreversible": "删除后不可恢复。",
  "customers.msg.saved": "已保存",
  "customers.msg.created": "客户已创建",
  "customers.form.name": "名称（客户 / 产品）",
  "customers.form.name.required": "请输入名称，如 東邦銀行",
  "customers.form.name.placeholder": "例：东邦银行 / 订货系统",
  "customers.form.shortName": "简称",
  "customers.form.shortName.placeholder": "可选，例：東邦 / 受発注",
  "customers.col.status": "状态",
  "customers.status.active": "有效",
  "customers.status.inactive": "无效",
  "customers.form.active": "状态",
  "customers.form.active.tip": "设为无效后，该客户将作为归档处理",

  // ===== PM 富文本编辑器 =====
  "pm.rte.uploading": "图片上传中…",
  "pm.rte.uploadFailed": "图片上传失败",
  "pm.rte.bold": "加粗",
  "pm.rte.italic": "斜体",
  "pm.rte.underline": "下划线",
  "pm.rte.strike": "删除线",
  "pm.rte.bulletList": "无序列表",
  "pm.rte.orderedList": "有序列表",
  "pm.rte.alignLeft": "左对齐",
  "pm.rte.alignCenter": "居中",
  "pm.rte.alignRight": "右对齐",
  "pm.rte.insertImage": "插入图片",
  "pm.rte.imgSmall": "图片：小",
  "pm.rte.imgMedium": "图片：中",
  "pm.rte.imgFull": "图片：满宽",
  "pm.rte.hint": "可直接粘贴 / 拖拽图片",
  "pm.rte.placeholder": "输入任务描述，可粘贴图片…",

  // ===== PM 甘特图 · 实际时间 =====
  "gantt.actual.ongoing": "实际 {start}~ 进行中（未完了）",
  "gantt.actual.range": "实际 {start}~{end}（{dur}）",
  "gantt.tip.planEffort": "计划工期",
  "gantt.tip.actualEffort": "实际工期",
  "gantt.foot.total": "总工期",
  "gantt.foot.planned": "计划",
  "gantt.foot.actual": "实际",
  "gantt.foot.note": "※ 按 1天 = {hpd}小时 换算",

  // ===== PM 思维导图（Mind Map） =====
  "mindmap.title": "思维导图",
  "mindmap.empty": "还没有思维导图，新建一个开始吧",
  "mindmap.noProject": "未关联项目",
  "mindmap.updatedAt": "更新于 {time}",
  "mindmap.notFound": "思维导图不存在或已删除",
  "mindmap.act.new": "新建导图",
  "mindmap.act.editInfo": "编辑信息",
  "mindmap.act.delete": "删除",
  "mindmap.act.back": "返回",
  "mindmap.act.addChild": "添加子节点 (Tab)",
  "mindmap.act.addSibling": "添加同级 (Enter)",
  "mindmap.act.nodeColor": "节点颜色",
  "mindmap.act.collapseAll": "全部折叠",
  "mindmap.act.expandAll": "全部展开",
  "mindmap.act.zoomIn": "放大",
  "mindmap.act.zoomOut": "缩小",
  "mindmap.act.fit": "适应窗口",
  "mindmap.act.exportPng": "导出 PNG",
  "mindmap.act.reload": "刷新",
  "mindmap.field.name": "名称",
  "mindmap.field.nameRequired": "请输入名称",
  "mindmap.field.namePlaceholder": "例：产品规划脑图",
  "mindmap.field.project": "关联项目（可选）",
  "mindmap.field.projectPlaceholder": "选择项目",
  "mindmap.msg.created": "已创建",
  "mindmap.msg.updated": "已更新",
  "mindmap.msg.deleted": "已删除",
  "mindmap.msg.confirmDelete": "确定删除「{name}」？",
  "mindmap.save.saved": "已保存",
  "mindmap.save.dirty": "未保存…",
  "mindmap.save.saving": "保存中…",
  "mindmap.save.error": "保存失败",
  "mindmap.save.conflict": "已被他人更新",
  "mindmap.theme.classic": "经典蓝",
  "mindmap.theme.dark": "暗色",
  "mindmap.theme.forest": "森林绿",
  "mindmap.theme.sunset": "落日橙",
  "mindmap.tip.rootUndeletable": "中心主题不可删除",
  "mindmap.hint.keys":
    "Tab 子节点 · Enter 同级 · 双击改名 · Delete 删除 · Ctrl/⌘+滚轮缩放",

  // 节假日（红日子）管理
  "pages.holidays.title": "节假日 / 红日子",
  "pages.holidays.teamHint":
    "节假日为租户级，修改对整个团队生效。工期与进度已自动排除周末与这些红日子。",
  "pages.holidays.syncNow": "立即同步",
  "pages.holidays.syncSuccess":
    "同步完成：新增 {added}、更新 {updated}、移除 {removed}",
  "pages.holidays.add": "新增",
  "pages.holidays.import": "批量导入",
  "pages.holidays.yearAll": "全部年份",
  "pages.holidays.col.date": "日期",
  "pages.holidays.col.name": "名称",
  "pages.holidays.col.source": "来源",
  "pages.holidays.col.action": "操作",
  "pages.holidays.source.manual": "手动",
  "pages.holidays.source.synced": "同步",
  "pages.holidays.edit": "编辑",
  "pages.holidays.delete": "删除",
  "pages.holidays.deleteConfirm": "确定删除这个红日子？",
  "pages.holidays.empty":
    "暂无节假日。点「立即同步」从 holidays-jp 拉取，或手动新增。",
  "pages.holidays.saved": "已保存",
  "pages.holidays.addTitle": "新增节假日",
  "pages.holidays.editTitle": "编辑节假日",
  "pages.holidays.form.date": "日期",
  "pages.holidays.form.dateRequired": "请选择日期",
  "pages.holidays.form.name": "名称",
  "pages.holidays.form.nameRequired": "请输入名称",
  "pages.holidays.form.namePlaceholder": "例：元旦",
  "pages.holidays.importTitle": "批量导入节假日",
  "pages.holidays.importHint":
    "每行一条：YYYY-MM-DD 名称（逗号 / 制表符 / 空格分隔）。已存在的日期会自动跳过。",
  "pages.holidays.importEmpty": "没有可导入的有效行",
  "pages.holidays.importResult": "已导入 {added} 条",

  // ===== 品質管理（Quality）=====
  "quality.title": "质量管理",
  "quality.subtitle": "测试用例的管理·执行记录与缺陷单管理",
  "quality.selectProject": "选择项目",
  "quality.noProject": "没有可显示的项目",
  "quality.tab.cases": "测试用例",
  "quality.tab.bugs": "缺陷管理",
  "quality.suite.title": "测试套件",
  "quality.suite.all": "全部",
  "quality.suite.add": "新增套件",
  "quality.suite.edit": "编辑套件",
  "quality.suite.name": "套件名称",
  "quality.suite.prefix": "编号前缀（如 STU）",
  "quality.suite.description": "说明",
  "quality.suite.deleteConfirm": "确定删除该套件及其下用例吗？",
  "quality.suite.empty": "暂无套件，请点击「新增套件」创建。",
  "quality.category.normal": "正常",
  "quality.category.abnormal": "异常",
  "quality.category.boundary": "边界值",
  "quality.result.pass": "OK",
  "quality.result.fail": "NG",
  "quality.result.na": "不适用",
  "quality.result.untested": "未执行",
  "quality.priority.high": "高",
  "quality.priority.medium": "中",
  "quality.priority.low": "低",
  "quality.severity.high": "高",
  "quality.severity.medium": "中",
  "quality.severity.low": "低",
  "quality.bugStatus.open": "待处理",
  "quality.bugStatus.inProgress": "处理中",
  "quality.bugStatus.resolved": "已修复",
  "quality.bugStatus.verifying": "验证中",
  "quality.bugStatus.closed": "已关闭",
  "quality.bugStatus.wontfix": "不处理",
  "quality.case.no": "编号",
  "quality.case.title": "测试观点",
  "quality.case.feature": "功能",
  "quality.case.category": "分类",
  "quality.case.priority": "优先级",
  "quality.case.result": "执行结果",
  "quality.case.assignee": "执行人",
  "quality.case.task": "任务",
  "quality.case.actions": "操作",
  "quality.case.add": "新增用例",
  "quality.case.edit": "编辑用例",
  "quality.case.deleteConfirm": "确定删除该用例吗？",
  "quality.case.precondition": "前提条件",
  "quality.case.steps": "测试步骤",
  "quality.case.testData": "测试数据",
  "quality.case.expected": "期望结果",
  "quality.case.remark": "备注",
  "quality.case.raiseBug": "提缺陷",
  "quality.case.batchResult": "批量记录执行结果",
  "quality.case.selectedN": "已选 {n} 项",
  "quality.case.searchPlaceholder": "按观点·功能·编号搜索",
  "quality.case.filterResult": "执行结果",
  "quality.case.filterCategory": "分类",
  "quality.case.filterPriority": "优先级",
  "quality.case.filterAssignee": "执行人",
  "quality.case.filterFeature": "功能",
  "quality.case.empty": "暂无用例",
  "quality.case.linkTask": "关联任务",
  "quality.suite.linkTask": "关联任务（可选）",
  "quality.case.unlinkTask": "解除关联",
  "quality.case.notLinked": "未关联",
  "quality.bug.no": "编号",
  "quality.bug.title": "标题",
  "quality.bug.severity": "影响度",
  "quality.bug.priority": "优先级",
  "quality.bug.status": "状态",
  "quality.bug.assignee": "负责人",
  "quality.bug.reporter": "报告人",
  "quality.bug.task": "任务",
  "quality.bug.noTask": "无匹配任务",
  "quality.bug.noDescription": "暂无说明。",
  "quality.bug.batchLinkN": "将选中{n}项关联到任务",
  "quality.bug.batchLinkedN": "已关联{n}项",
  "quality.bug.batchUnlink": "解除关联",
  "quality.bug.batchUnlinkConfirm": "解除选中{n}项的任务关联？",
  "quality.bug.linkExisting": "关联已有缺陷",
  "quality.bug.linkExistingHint": "选择要关联到此任务的已有缺陷。",
  "quality.bug.selectBugs": "选择缺陷",
  "quality.bug.project": "产品/项目",
  "quality.bug.wholeProduct": "（整个产品）",
  "quality.bug.selectProduct": "请选择产品或项目",
  "quality.bug.movedTo": "已移动到「{product}」（重新编号）",
  "quality.bug.createdAt": "起票时间",
  "quality.bug.reportedOn": "起票日期",
  "quality.bug.resolvedAt": "完成日期",
  "quality.bug.testCase": "来源用例",
  "quality.bug.actions": "操作",
  "quality.bug.add": "提缺陷",
  "quality.bug.detail": "详情",
  "quality.bug.edit": "编辑",
  "quality.bug.deleteConfirm": "确定删除该缺陷单吗？",
  "quality.bug.description": "内容（复现步骤/期望/实际）",
  "quality.bug.environment": "环境",
  "quality.bug.reopenCount": "重开 {n} 次",
  "quality.bug.filterStatus": "状态",
  "quality.bug.filterSeverity": "影响度",
  "quality.bug.filterPriority": "优先度",
  "quality.bug.filterAssignee": "担当者",
  "quality.bug.reportedFrom": "起票日 从",
  "quality.bug.reportedTo": "起票日 至",
  "quality.bug.resolvedFrom": "完成日 从",
  "quality.bug.resolvedTo": "完成日 至",
  "quality.bug.empty": "暂无缺陷单",
  "quality.bug.fromCase": "由用例 {caseNo} 提交",
  "quality.bug.tabCount": "未完成 {active} / 全部 {total}",
  "quality.bug.statusActive": "未完成",
  "quality.bug.overview.active": "未完成",
  "quality.bug.overview.highSeverity": "影响度·高",
  "quality.bug.overview.oldest": "最早的未完成",
  "quality.bug.overview.days": "天",
  "quality.bug.overview.thisWeek": "本周：提交 +{reported} ／ 完成 {resolved}",
  "quality.bug.searchPlaceholder": "按编号、标题、说明搜索",
  "quality.bug.filterProject": "项目",
  "quality.bug.wholeProductShort": "整个产品",
  "quality.bug.advancedFilter": "更多筛选",
  "quality.bug.filterTask": "关联任务",
  "quality.bug.taskLinked": "已关联",
  "quality.bug.taskUnlinked": "未关联",
  "quality.bug.clearFilters": "清除条件",
  "quality.bug.export": "导出",
  "quality.bug.settings": "设置",
  "quality.bug.columns": "显示列",
  "quality.bug.ageDays": "已 {n} 天",
  "quality.bug.more": "更多操作",
  "quality.bug.duplicate": "复制并提交",
  "quality.bug.copyLink": "复制链接",
  "quality.bug.linkCopied": "链接已复制",
  "quality.bug.selectedN": "已选 {n} 条",
  "quality.bug.batchStatus": "修改状态",
  "quality.bug.batchAssignee": "修改负责人",
  "quality.bug.batchLink": "关联到任务",
  "quality.bug.batchDeleteConfirm": "确定删除选中的 {n} 条缺陷单吗？",
  "quality.bug.clearSelection": "取消选择",
  "quality.bug.pageTotal": "共 {total} 条，第 {start}–{end} 条",
  "quality.bug.chip.reported": "提交日：{v}",
  "quality.bug.chip.resolved": "完成日：{v}",
  "quality.bug.chip.task": "关联任务：{v}",
  "quality.bug.chip.reporter": "报告人：{v}",
  "quality.bug.chip.environment": "环境：{v}",
  "quality.bug.reopenCountHeader": "重开次数",
  "quality.bug.resolvedAtHint": "状态改为「已修复」「已关闭」时自动记录",
  "quality.common.undo": "撤销",
  "quality.msg.undone": "已撤销",
  "quality.common.save": "保存",
  "quality.common.cancel": "取消",
  "quality.common.all": "全部",
  "quality.common.unassigned": "未分配",
  "quality.common.openGantt": "在甘特图打开",
  "quality.common.delete": "删除",
  "quality.common.add": "新增",
  "quality.common.close": "关闭",
  "quality.common.actions": "操作",
  "quality.env.manage": "环境主数据",
  "quality.env.select": "选择环境",
  "quality.env.empty": "尚未登记环境",
  "quality.env.emptyForProduct": "该产品尚未登记环境",
  "quality.env.name": "区分",
  "quality.env.browser": "终端/浏览器",
  "quality.env.url": "URL",
  "quality.env.namePlaceholder": "dev / stg / prod",
  "quality.env.browserPlaceholder": "Chrome / iOS Safari",
  "quality.env.urlPlaceholder": "https://dev.example.jp",
  "quality.env.deleteConfirm": "确定删除该环境？",
  "quality.msg.saved": "已保存",
  "quality.msg.deleted": "已删除",
  "quality.msg.resultUpdated": "执行结果已更新",
  "quality.msg.batchDone": "已更新 {n} 项",
  "quality.msg.bugRaised": "已提交缺陷单 {bugNo}",
  "quality.msg.statusUpdated": "状态已更新",
  "quality.msg.selectCases": "请先选择用例",
  "quality.summary.execution": "消化率",
  "quality.task.openInQuality": "在质量管理中打开",

  // 任务跨案件检索（命令面板 ⌘K）
  "search.entry": "搜索",
  "search.placeholder": "搜索任务 / 案件 / 缺陷",
  "search.hint": "可按任务名、案件名、客户名、缺陷编号搜索",
  "search.empty": "没有匹配「{kw}」的结果",
  "search.kind.all": "全部",
  "search.kind.task": "任务",
  "search.kind.project": "案件",
  "search.kind.bug": "缺陷",
  "search.overdueDays": "超期 {n} 天",
  "search.openTasks": "未完成 {n} 个",
  "search.foot.move": "移动",
  "search.foot.open": "打开",
  "search.foot.openProject": "打开案件",

  // WBS / 看板内的关键词筛选（跨案件搜索走 ⌘K 面板）
  "projects.gantt.filter.placeholder": "按任务名筛选",
  "projects.gantt.filter.hits": "{n} 条",
  "projects.gantt.filter.empty": "没有匹配「{kw}」的任务",
  "projects.gantt.filter.clear": "清除筛选",

  // 資料（外部ドライブのリンク：顧客 / 案件 / タスク）。設計 doc/design/pm-drive-docs.md
  "docs.title": "资料",
  "docs.projectButton": "项目资料 ({n})",
  "docs.add": "添加资料",
  "docs.linkToTask": "关联资料",
  "docs.open": "在新标签页打开",
  "docs.empty": "还没有登记的资料",
  "docs.filterEmpty": "没有符合条件的资料",
  "docs.unlinkedEmpty": "没有未关联任务的资料",
  "docs.taskEmpty": "此任务还没有关联资料",
  "docs.selectToPreview": "选择资料后在此预览",
  "docs.deleteConfirm": "确定移除「{name}」的登记吗？",
  "docs.deleteConfirm.desc": "不会删除网盘中的文件，只移除 PM 中的登记与任务关联。",
  "docs.remove": "移除",
  "docs.unlinkConfirm": "确定取消与此任务的关联吗？",
  "docs.unlink": "取消关联",
  "docs.linkTasks": "关联任务",
  "docs.linkTasks.title": "关联的任务",
  "docs.linkTasks.note": "将以所选任务替换现有关联；清空则变为未关联。",
  "docs.common": "客户共通",
  "docs.projectWide": "整个项目",
  "docs.unlinked": "未关联",
  "docs.addedBy": "添加人 {name}",
  "docs.group.project": "项目",
  "docs.provider.google": "Google 云端硬盘",
  "docs.provider.microsoft": "SharePoint",
  "docs.provider.box": "Box",
  "docs.provider.other": "链接",
  "docs.kind.gdoc": "Google 文档",
  "docs.kind.gsheet": "Google 表格",
  "docs.kind.gslide": "Google 幻灯片",
  "docs.kind.gfile": "文件",
  "docs.kind.gfolder": "文件夹",
  "docs.kind.ms": "Microsoft 365 文件",
  "docs.kind.box": "Box 文件",
  "docs.kind.link": "外部链接",
  "docs.type.all": "全部类型",
  "docs.type.pdf": "PDF",
  "docs.type.xls": "表格",
  "docs.type.doc": "文档",
  "docs.type.ppt": "幻灯片",
  "docs.type.img": "图片",
  "docs.type.folder": "文件夹",
  "docs.type.file": "其他文件",
  "docs.type.link": "链接",
  "docs.preview.hint": "无法显示时，可能是没有查看权限、登录了其他账号，或浏览器拦截了嵌入内容。",
  "docs.fallback.title": "此资料无法预览",
  "docs.fallback.google": "无法从 URL 读取 Google 云端硬盘的文件 ID。改用文件的共享链接重新登记，或许即可预览。",
  "docs.fallback.microsoft": "SharePoint / OneDrive 的资料目前仅支持链接，请在新标签页中打开查看。",
  "docs.fallback.box": "Box 的资料目前仅支持链接，请在新标签页中打开查看。",
  "docs.fallback.other": "这是外部网站的链接，请在新标签页中打开查看。",
  "docs.root.customer": "客户根文件夹",
  "docs.root.project": "项目文件夹",
  "docs.root.unsetCustomer": "尚未设置客户根文件夹",
  "docs.root.unsetProject": "尚未设置项目文件夹",
  "docs.root.unsetHint": "设置 Google 云端硬盘文件夹后，可在此浏览其内容",
  "docs.root.set": "设置文件夹",
  "docs.root.change": "更改",
  "docs.root.remove": "取消设置",
  "docs.drawer.stats": "案件 {projects} 个・资料 {docs} 个",
  "docs.root.bannerHint": "文件仍保存在客户的云端硬盘中。PM 只保存链接和关联关系，查看权限以云端硬盘的共享设置为准。",
  "docs.root.openFolder": "打开根文件夹",
  "docs.root.removeConfirm": "确定取消文件夹设置吗？",
  "docs.view.registered": "已登记资料 ({n})",
  "docs.view.unlinked": "未关联 ({n})",
  "docs.folder.registerHint": "通过右上角「添加资料」登记此文件夹中的文件后，即可在此预览并关联任务",
  "docs.form.url.folder": "文件夹不能作为资料登记。请设为根文件夹（案件文件夹），或登记其中的文件",
  "docs.search.placeholder": "按名称、URL、任务名搜索",
  "docs.col.name": "名称",
  "docs.col.provider": "存储位置",
  "docs.col.target": "关联对象",
  "docs.col.createdAt": "添加日期",
  "docs.drawer.customer": "客户资料",
  "docs.drawer.project": "项目资料",
  "docs.form.addTitle": "添加资料",
  "docs.form.rootTitle": "设置文件夹",
  "docs.form.mode.new": "通过 URL 登记",
  "docs.form.mode.existing": "从已登记中选择",
  "docs.form.url": "共享链接（URL）",
  "docs.form.url.placeholder": "粘贴 Google 云端硬盘、SharePoint、Box 等的共享链接",
  "docs.form.url.rootPlaceholder": "粘贴 Google 云端硬盘文件夹的共享链接",
  "docs.form.url.extra": "文件仍保存在网盘中，查看权限遵循网盘的共享设置。",
  "docs.form.url.rootExtra": "如已设置文件夹，将被替换。",
  "docs.form.url.required": "请输入 URL",
  "docs.form.url.invalid": "请输入以 http:// 或 https:// 开头的 URL（2000 字以内）",
  "docs.form.title": "显示名称",
  "docs.form.title.placeholder": "可选（留空则显示文件名或域名）",
  "docs.form.scope": "关联到",
  "docs.form.scope.task": "任务",
  "docs.form.project": "项目",
  "docs.form.project.required": "请选择项目",
  "docs.form.tasks": "任务",
  "docs.form.tasks.placeholder": "选择任务（可按 WBS 路径搜索）",
  "docs.form.tasks.required": "请至少选择 1 个任务",
  "docs.form.existing": "资料",
  "docs.form.existing.placeholder": "选择此项目中已登记的资料",
  "docs.form.existing.required": "请至少选择 1 份资料",
  "docs.hint.preview": "已识别为 {kind}（可预览）",
  "docs.hint.linkOnly": "将作为 {provider} 链接登记（不可预览，在新标签页打开）",
  "docs.msg.added": "已添加资料",
  "docs.msg.linked": "已关联",
  "docs.msg.removed": "已移除",
  // Google Picker（第二步）。設計 doc/design/pm-drive-docs.md §7
  "docs.msg.addedN": "已添加 {n} 个资料",
  "docs.emptyWithFolder": "通过右上角「添加资料」从根文件夹中选择文件登记。登记后的资料可在此预览并关联任务",
  "docs.defaultName.folder.google": "Google 云端硬盘文件夹",
  "docs.defaultName.folder.microsoft": "SharePoint 文件夹",
  "docs.defaultName.folder.box": "Box 文件夹",
  "docs.defaultName.folder.other": "共享文件夹",
  "docs.defaultName.gfile": "Google 云端硬盘文件",
  "docs.chip.all": "全部",
  "docs.chip.pdf": "PDF",
  "docs.chip.xls": "Excel",
  "docs.chip.doc": "Word",
  "docs.chip.ppt": "PowerPoint",
  "docs.chip.img": "图片",
  "docs.chip.folder": "文件夹",
  "docs.form.mode.google": "从 Google 云端硬盘选择",
  "docs.form.mode.googleFolder": "从 Google 云端硬盘选择",
  "docs.picker.title": "选择要登记到 PM 的资料",
  "docs.picker.titleFolder": "选择文件夹",
  "docs.picker.view.thisFolder": "此文件夹",
  "docs.picker.view.myDrive": "我的云端硬盘",
  "docs.picker.view.sharedDrives": "共享云端硬盘",
  "docs.picker.disabled": "尚未配置 Google 云端硬盘集成",
  "docs.picker.disabled.desc": "管理员配置 Google Picker（API 密钥与 OAuth 客户端）后，即可直接从云端硬盘选择文件。在此之前请使用「通过 URL 登记」。",
  "docs.picker.pick": "从 Google 云端硬盘选择文件",
  "docs.picker.pickMore": "继续选择",
  "docs.picker.pickFolder": "从 Google 云端硬盘选择文件夹",
  "docs.picker.repickFolder": "重新选择文件夹",
  "docs.picker.removeItem": "移出选择",
  "docs.picker.note": "选择文件夹会一并添加其中的文件。文件仍保存在云端硬盘，访问权限遵循云端硬盘的共享设置。",
  "docs.picker.required": "请至少选择 1 个文件",
  "docs.picker.titleInFolder": "选择「{name}」中的文件",
  "docs.picker.expanded": "已从「{name}」添加 {n} 个文件",
  "docs.picker.skipDup": "已跳过 {n} 个已登记的文件",
  "docs.picker.importFiles": "同时把文件夹内的文件登记为资料",
  "docs.msg.rootImported": "已设置根文件夹并登记 {n} 个文件",
  "docs.picker.addN": "添加 {n} 个",
  "docs.picker.err.config": "无法获取 Google 云端硬盘集成设置，请稍后重试。",
  "docs.picker.err.load": "无法加载 Google 脚本。请检查网络连接，以及拦截广告/跟踪的浏览器扩展。",
  "docs.picker.err.popup": "无法打开 Google 登录窗口。请允许本站弹出窗口后重试。",
  "docs.picker.err.auth": "Google 授权失败。请稍后重试或联系管理员。",
  "docs.picker.err.scope": "未授予云端硬盘访问权限。请在同意页面勾选 Google 云端硬盘项。",
};
